import API from './index';
import '../helpers';

function getDashboard(params) {
	const options = {
		method: 'GET',
		headers: {
			'auth-token': `${params.data.authToken}`
		}
	};
	return API.get('/dashboard', options)
		.then((result) => {
			return result;
		})
		.catch((error) => {
			throw error.response;
		});
}


export const dashboardService = {
	getDashboard
};
